import axios from 'axios/dist/axios'

export { axios }

export default class APIClient {

  constructor (config) {
    this._client = axios.create({
      timeout: 15000,
      withCredentials: true,
      ...config
    })
  }

  call (...args) {
    return this._client(...args)
  }

  justData ({data}) {
    return data
  }

  get (url, params = {}) {
    return this._client.get(url, {
      params
    })
  }

  put (url, data, config = {}) {
    return this._client.put(url, data, config)
  }

  post (url, data, config = {}) {
    return this._client.post(url, data, config)
  }

  delete (url, data, config = {}) {
    return this._client.delete(url, {
      data,
      ...config
    })
  }

  head (url, config = {}) {
    return this._client.head(url, config)
  }
}
